// extracted by mini-css-extract-plugin
export default {"logoSection":"styles_logoSection__CMa6x"};